export default {
  title: {
    edit: 'Update the member',
    create: 'Create a new member',
  },
  form: {
    user: 'Member',
    email: 'Email',
    role: 'Role',
    roles: {
      admin: 'Administrator',
      setter: 'Route Setter',
    },
    submit: 'Save',
  },
  delete: {
    button: 'Delete this member',
    confirm: {
      title: 'Please confirm the deletion of the member',
      submit: 'Delete',
    },
  },
}
